import * as types from "../../constants";
import { AuthService } from "../../services";

export function signIn(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return AuthService.signIn(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function signOut() {
  return async (dispatch) => {
    await AuthService.signOut();

    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}
